<script>
import { mapState } from 'vuex';

export default {
    name: "updataPwd",
    data() {
        return {
            // password: '',
            newpassword: '',
            passwordAgain: '',
            // isForget: false,
            // phone: '',
            code: '',
            isLoading: false,
            isCodeLoading: false,
            countdown: 0,
            time: null,
        };
    },
    computed: {
        ...mapState(['userinfo']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 设置倒计时
        setCountdown() { 
            this.countdown = 59;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            // if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
            //     this.$refs.phone.focus();
            //     this.$showToast({ text: '请输入手机号' });
            //     return false;
            // }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.userinfo.phone,
                type: 3
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        // 提交修改
        submit(){
            if (this.isLoading) { 
                return;
            }
            // 修改密码
            // if (!this.isForget) { 
            //     if(this.password.replace(/(^\s*)|(\s*$)/g, "").length == 0){
            //         this.$refs.password.focus();
            //         this.$showToast({ text: '请输入现有密码' });
            //         return false;
            //     }
            // }
            if(this.newpassword.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.newpassword.focus();
                this.$showToast({ text: '请输入新密码' });
                return false;
            }
            if(this.passwordAgain.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.passwordAgain.focus();
                this.$showToast({ text: '请再输入新密码' });
                return false;
            }
            if(this.newpassword != this.passwordAgain){
                this.$refs.passwordAgain.focus();
                this.$showToast({ text: '两次输入的密码不一致' });
                return false;
            }
            if(this.code.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.code.focus();
                this.$showToast({ text: '请输入验证码' });
                return false;
            }
            // todo 提交修改
            this.isLoading = true;
            this.$store.dispatch('updatePwd', {
                // ...(this.isForget ? { phone: this.phone } : { password: this.password }),
                new_password: this.newpassword,
                confirm_password: this.passwordAgain,
                code: this.code,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.$showToast({ text: '密码修改成功' });
                    // 清空表单
                    // this.password = '';
                    this.newpassword = '';
                    this.passwordAgain = '';
                    this.code = '';
                } else {
                    this.$showToast({ text: result.msg || '密码修改失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '密码修改失败' });
            });
        },
    },
};
</script>

<template>
    <div class="updataPwd">
        <p class="title only_pc">修改密码</p>
        <!-- 修改密码 -->
        <!-- <template v-if="!isForget"> -->
            <div class="form edit">
                <!-- <div class="item">
                    <p class="name">现有密码：</p>
                    <input type="password" placeholder="请输入密码" ref="password" v-model="password"/>
                    <p class="text r">*</p>
                </div> -->
                <div class="item">
                    <p class="name">新密码：</p>
                    <input type="password" placeholder="请输入新密码" ref="newpassword" v-model="newpassword"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">重复新密码：</p>
                    <input type="password" placeholder="请再输入新密码" ref="passwordAgain" v-model="passwordAgain"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">电话号码：</p>
                    <p>{{ userinfo.phone }}</p>
                </div>
                <div class="item">
                    <p class="name">手机验证码：</p>
                    <input class="code" type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="6"/>
                    <div class="btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                    <p class="text r">*</p>
                </div>
                <!-- <div class="item">
                    <p>忘记密码？<a href="javascript:;" class="btn_forget" @click="isForget = true">重置密码</a></p>
                </div> -->
            </div>
            <div class="flex justify_end btn_bottom_group">
                <div class="btn_submit layout_flex_center" @click="submit">确认修改</div>
            </div>
        <!-- </template> -->
        <!-- <template v-else>
            <div class="form row edit">
                <div class="item">
                    <p class="name">电话号码：</p>
                    <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">手机验证码：</p>
                    <input class="code" type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="11"/>
                    <div class="btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">新密码：</p>
                    <input type="password" placeholder="请输入新密码" ref="newpassword" v-model="newpassword"/>
                    <p class="text r">*</p>
                </div>
                <div class="item only_pc"></div>
                <div class="item">
                    <p class="name">重复新密码：</p>
                    <input type="password" placeholder="请再输入新密码" ref="passwordAgain" v-model="passwordAgain"/>
                    <p class="text r">*</p>
                </div>
                <div class="item"></div>
                <div class="item">
                    <p><a href="javascript:;" class="btn_back" @click="isForget = false">&lt;返回</a></p>
                </div>
            </div>
            <div class="flex justify_end btn_bottom_group">
                <div class="btn_submit layout_flex_center" @click="submit">确认修改</div>
            </div>
        </template> -->
    </div>
</template>

<style scoped lang="scss">
.updataPwd{
    .btn_forget{
        border-bottom: 1px solid var(--font_color);
    }
    .btn_back{
        &:hover{
            border-bottom: 1px solid var(--font_color);
        }
    }
    .form{
        .item{
            width: calc(50% - .1rem);
            @media screen and (max-width: 750px) {
                width: 100%;
            }
        }
    }
}
</style>